<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title sliding>{{$t('perfil.perfil')}}</f7-nav-title>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-block-title>
      Contrase�a
    </f7-block-title>
      <f7-card class="padding-vertical-half padding-right" style="z-index: 2;">
        <f7-card-content>
          <f7-row>
            <f7-button
              fill
              icon-f7="lock"
              text="Cambiar Contrase�a"
              class="display-flex"
              popup-open=".popup-cambio-pass"
              width="100"
              medium="30"
            ></f7-button>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <f7-popup ref="popupCambioPass" class="popup-cambio-pass" swipe-to-close>
        <f7-page>
          <f7-navbar title="Cambiar Contrase�a">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>

          <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
        <f7-card
          class="elevation-3 padding-vertical-half padding-right"
        >
        <f7-list form>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-floating-label">{{$t('perfil.actual_pass')}}</div>
              <div class="item-input-wrap">
                <input type="password" name="oldPassword" placeholder />
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-floating-label">{{$t('perfil.new_pass')}}</div>
              <div class="item-input-wrap">
                <input type="password" name="newPassword" placeholder />
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-floating-label">{{$t('perfil.repeat_new_pass')}}</div>
              <div class="item-input-wrap">
                <input type="password" name="repeatPassword" placeholder />
              </div>
            </div>
          </li>
        </f7-list>
        <f7-button
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="saveCambioPass"
          ></f7-button>
        </f7-card>
          <!-- </div> -->
        </f7-page>
      </f7-popup>

      <template v-if="esCordova">
        <f7-block-title>Permisos de la app
          <f7-link class="margin-left" @click="cargarPermisos">Actualizar</f7-link>
        </f7-block-title>
        <f7-card class="padding-vertical-half padding-right">
          <f7-card-content>
            <div class="list">
              <ul>
                <li v-for="p in permisos" :key="p.key">
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title">{{ p.label }}</div>
                      <div class="item-after">
                        <span class="badge" :class="estadoColor(p.estado)" style="cursor: pointer;" @click="togglePermiso(p)">{{ estadoTexto(p.estado) }}</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="!permisos.length">
                  <div class="item-content"><div class="item-inner">
                    <div class="item-title text-color-gray">{{ cargandoPermisos ? 'Consultando...' : 'Sin datos de permisos' }}</div>
                  </div></div>
                </li>
              </ul>
            </div>
          </f7-card-content>
        </f7-card>

        <f7-block-title>Almacenamiento
          <f7-link class="margin-left" @click="cargarAlmacenamiento">Actualizar</f7-link>
        </f7-block-title>
        <f7-card class="padding-vertical-half padding-right">
          <f7-card-content>
            <div class="list">
              <ul>
                <li>
                  <div class="item-content"><div class="item-inner">
                    <div class="item-title">localStorage</div>
                    <div class="item-after">{{ formatBytes(almacenamiento.localStorageBytes) }}</div>
                  </div></div>
                </li>
                <li>
                  <div class="item-content"><div class="item-inner">
                    <div class="item-title">Base de datos y archivos (disco)</div>
                    <div class="item-after">{{ almacenamiento.cargando ? 'Calculando...' : formatBytes(almacenamiento.discoBytes) }}</div>
                  </div></div>
                </li>
                <li v-for="d in almacenamiento.desglose" :key="d.nombre">
                  <div class="item-content"><div class="item-inner">
                    <div class="item-title" style="padding-left:16px; color:#888;">{{ d.nombre }}</div>
                    <div class="item-after">{{ formatBytes(d.bytes) }}</div>
                  </div></div>
                </li>
                <li v-if="almacenamiento.error">
                  <div class="item-content"><div class="item-inner">
                    <div class="item-title text-color-red">{{ almacenamiento.error }}</div>
                  </div></div>
                </li>
              </ul>
            </div>
          </f7-card-content>
        </f7-card>
      </template>
  </f7-page>
</template>
<style scoped>
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}
.btn-cliente {
  width: 200px;
  float: right;
}
</style>
<script>
import Vue from "vue";
import Usuario from "./../../js/db/Usuario.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import rForm from "./../../components/rForm.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import rInput from "./../../components/rInput.vue";
import rFiles from "./../../components/rFiles.vue";


export default {
  components: {
    rForm,
    rAutocomplete,
    rInput,
    rFiles
  },
  data: function() {
    var self = this;
    return {
      Usuario,
      esCordova: false,
      cargandoPermisos: false,
      permisos: [],
      almacenamiento: {
        cargando: false,
        localStorageBytes: 0,
        discoBytes: null,
        desglose: [],
        error: null
      }
    };
  },
  props: {
  },
  computed: {},
  beforeDestroy() {},
  created: function() {
    this.esCordova = (typeof cordova !== "undefined" && cordova.platformId === "android");
  },
  methods: {
    estadoTexto: function(estado) {
      if (estado === "concedido") return "Concedido";
      if (estado === "denegado") return "Denegado";
      return "N/D";
    },
    estadoColor: function(estado) {
      if (estado === "concedido") return "color-green";
      if (estado === "denegado") return "color-red";
      return "color-gray";
    },
    formatBytes: function(bytes) {
      if (bytes === null || bytes === undefined) return "N/D";
      if (bytes < 1024) return bytes + " B";
      var kb = bytes / 1024;
      if (kb < 1024) return kb.toFixed(1) + " KB";
      var mb = kb / 1024;
      if (mb < 1024) return mb.toFixed(1) + " MB";
      return (mb / 1024).toFixed(2) + " GB";
    },
    // Estado real (concedido/denegado) de los permisos runtime via cordova-plugin-android-permissions.
    cargarPermisos: function() {
      var self = this;
      if (!self.esCordova) return;
      var defs = [
        { key: "CAMERA", label: "Camara" },
        { key: "RECORD_AUDIO", label: "Microfono" },
        { key: "ACCESS_FINE_LOCATION", label: "Ubicacion (precisa)" },
        { key: "ACCESS_COARSE_LOCATION", label: "Ubicacion (aproximada)" },
        { key: "READ_EXTERNAL_STORAGE", label: "Leer almacenamiento" },
        { key: "WRITE_EXTERNAL_STORAGE", label: "Escribir almacenamiento" },
        { key: "READ_PHONE_STATE", label: "Estado del telefono" }
      ];
      var api = (window.cordova && cordova.plugins && cordova.plugins.permissions) ? cordova.plugins.permissions : null;
      if (!api) {
        self.permisos = defs.map(function(d) { return Object.assign({}, d, { estado: "desconocido" }); });
        return;
      }
      self.cargandoPermisos = true;
      Promise.all(defs.map(function(d) {
        return new Promise(function(resolve) {
          var permiso = api[d.key];
          if (!permiso) { resolve(Object.assign({}, d, { estado: "desconocido" })); return; }
          api.checkPermission(permiso, function(status) {
            resolve(Object.assign({}, d, { estado: (status && status.hasPermission) ? "concedido" : "denegado" }));
          }, function() {
            resolve(Object.assign({}, d, { estado: "desconocido" }));
          });
        });
      })).then(function(res) {
        self.permisos = res;
        self.cargandoPermisos = false;
      });
    },
    // Tocar el chip: si esta denegado, solicita el permiso (dialogo del sistema). Si esta
    // concedido, avisa de que Android solo permite retirarlo desde los Ajustes del sistema.
    togglePermiso: function(p) {
      var self = this;
      var app = self.$f7;
      var api = (window.cordova && cordova.plugins && cordova.plugins.permissions) ? cordova.plugins.permissions : null;
      if (!api || !p) return;
      var permiso = api[p.key];
      if (!permiso) return;
      if (p.estado === "concedido") {
        app.dialog.alert("Para retirar un permiso ya concedido debes hacerlo desde los Ajustes del sistema: Ajustes > Aplicaciones > SIMECAL > Permisos.", "Permiso concedido");
        return;
      }
      api.requestPermission(permiso, function(status) {
        var concedido = !!(status && status.hasPermission);
        self.$set(p, "estado", concedido ? "concedido" : "denegado");
        if (!concedido) {
          app.dialog.alert("El permiso sigue denegado. Si no aparece el dialogo del sistema (por haberlo rechazado antes de forma permanente), activalo en Ajustes > Aplicaciones > SIMECAL > Permisos.", "Permiso denegado");
        }
      }, function() {
        self.$set(p, "estado", "denegado");
      });
    },
    calcularLocalStorage: function() {
      var total = 0;
      try {
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          var v = localStorage.getItem(k);
          total += ((k ? k.length : 0) + (v ? v.length : 0)) * 2; // bytes aprox (UTF-16)
        }
      } catch (e) {}
      return total;
    },
    // Tamano recursivo en disco de un fileEntry/dirEntry (cordova-plugin-file).
    medirEntry: function(entry) {
      var self = this;
      return new Promise(function(resolve) {
        if (entry.isFile) {
          entry.getMetadata(function(meta) { resolve((meta && meta.size) || 0); }, function() { resolve(0); });
        } else if (entry.isDirectory) {
          var reader = entry.createReader();
          var acc = 0;
          var leerLote = function() {
            reader.readEntries(function(entries) {
              if (!entries.length) { resolve(acc); return; }
              Promise.all(entries.map(function(e) { return self.medirEntry(e); })).then(function(sizes) {
                acc += sizes.reduce(function(a, b) { return a + b; }, 0);
                leerLote(); // readEntries devuelve por lotes: repetir hasta vacio
              });
            }, function() { resolve(acc); });
          };
          leerLote();
        } else {
          resolve(0);
        }
      });
    },
    // Mide el directorio de datos de la app (incluye BD local de Mongo y archivos) y su desglose.
    calcularDisco: function() {
      var self = this;
      return new Promise(function(resolve) {
        if (!window.resolveLocalFileSystemURL || !window.cordova || !cordova.file || !cordova.file.dataDirectory) {
          resolve({ total: null, desglose: [], error: "API de ficheros no disponible" });
          return;
        }
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function(dirEntry) {
          var reader = dirEntry.createReader();
          var items = [];
          var leerLote = function() {
            reader.readEntries(function(entries) {
              if (!entries.length) {
                Promise.all(items.map(function(e) {
                  return self.medirEntry(e).then(function(bytes) { return { nombre: e.name, bytes: bytes }; });
                })).then(function(desglose) {
                  var total = desglose.reduce(function(a, b) { return a + (b.bytes || 0); }, 0);
                  desglose.sort(function(a, b) { return b.bytes - a.bytes; });
                  resolve({ total: total, desglose: desglose, error: null });
                });
                return;
              }
              items = items.concat(entries);
              leerLote();
            }, function() {
              resolve({ total: null, desglose: [], error: "No se pudo leer el almacenamiento" });
            });
          };
          leerLote();
        }, function() {
          resolve({ total: null, desglose: [], error: "No se pudo acceder al almacenamiento" });
        });
      });
    },
    cargarAlmacenamiento: function() {
      var self = this;
      self.almacenamiento.localStorageBytes = self.calcularLocalStorage();
      if (!self.esCordova) return;
      self.almacenamiento.cargando = true;
      self.almacenamiento.error = null;
      self.calcularDisco().then(function(res) {
        self.almacenamiento.discoBytes = res.total;
        self.almacenamiento.desglose = res.desglose;
        self.almacenamiento.error = res.error;
        self.almacenamiento.cargando = false;
      });
    },
    beforeSave: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      data.clienteContactos.forEach((cc,i) => self.$set(data.clienteContactos[i], 'firma', Array.isArray(cc.firma) ? cc.firma[0] : cc.firma));
      resolve(data);
    },
    getUser: function() {
      var user = localStorage.getItem("user");
      if (typeof user != "undefined" && user) {
        var userObj = JSON.parse(user);
        return userObj;
      }
      return null;
    },
    saveCambioPass: function(e) {
      var self = this;
      var app = self.$f7;
      var $el = self.$$(self.$refs.popupCambioPass.$el);
      var data = app.form.convertToData($el.find("form"));
      if (!data.oldPassword || data.oldPassword == '') {
        app.dialog.alert("Introduzca la contrase�a actual.");
        return;
      }
      if (!data.newPassword || data.newPassword == '') {
        app.dialog.alert("Introduzca la nueva contrase�a.");
        return;
      }
      if (!data.repeatPassword || data.repeatPassword == '') {
        app.dialog.alert("Introduzca la repetici�n de la nueva contrase�a.");
        return;
      }
      if (data.newPassword != data.repeatPassword) {
        app.dialog.alert("Las nuevas contrase�as no coinciden");
        return;
      }
      // #663 · La espera de la sesión: si la sesión se cierra en vuelo, el modal no se queda encima del acceso.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Usuario.cambiarPass(data)
        .then(function(res) {
          espera.cerrar();
          app.toast
            .create({
              text: 'Contrase�a Cambiada',
              position: "center",
              closeTimeout: 2000
            })
            .open();
          self.$refs.popupCambioPass.close(true);
        })
        .catch(function(e) {
          espera.cerrar();
          app.toast
            .create({
              text: e.error_description,
              position: "center",
              closeTimeout: 2000
            })
            .open();
        });
    }
  },
  mounted: function() {
    var self = this;
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    var user = self.getUser();
    self.cargarAlmacenamiento();
    if (self.esCordova) {
      self.cargarPermisos();
    }
  }
};
</script>
